import screen from './Main';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/PreRegistration/Detail/index.js